import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

const ConfirmDisableModal = ({ open, onClose, onConfirm,message }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Confirm Disable</DialogTitle>
      <DialogContent>
        <Typography>Are you sure you want to disable this {message}? This action cannot be undone.</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="outlined">Cancel</Button>
        <Button onClick={onConfirm} color="error" variant="contained">Yes, Disable</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDisableModal;
